<div class="layout-wrapper">
  <div class="layout-wrapper-inner vh-100 overflow-hidden">
    <div class="layout-body d-flex h-100">
      @if ((showSideMenu)) {
        <div>
          <app-sidemenu></app-sidemenu>
        </div>
      }
      <div class="right-content flex-fill position-relative">
        @if (showMainHeader) {
          <app-layout-header></app-layout-header>
        }
        <div class="right-side-component" [ngClass]="{'vh-100' : !showMainHeader}">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>

    <!-- <app-notifications *ngIf="!user_profile.agent_id"></app-notifications> -->
    <app-notifications></app-notifications>
  </div>
</div>